export default "__VITE_ASSET__QSDjEnbV__"